// ipwhois.app blocks browser (CORS) calls on its free plan, which crashed /select-plan.
// Products are only priced in EUR and USD, so the browser time zone is enough to pick one.
// Keeps the old { data: { currency_code } } shape so callers don't change.
const EURO_TIME_ZONES = new Set([
  'Africa/Ceuta',
  'Asia/Famagusta',
  'Asia/Nicosia',
  'Atlantic/Azores',
  'Atlantic/Canary',
  'Atlantic/Madeira',
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Athens',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Dublin',
  'Europe/Helsinki',
  'Europe/Lisbon',
  'Europe/Ljubljana',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Mariehamn',
  'Europe/Monaco',
  'Europe/Nicosia',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/San_Marino',
  'Europe/Sofia',
  'Europe/Tallinn',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Zagreb',
]);

export default async () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return { data: { currency_code: EURO_TIME_ZONES.has(timeZone) ? 'EUR' : 'USD' } };
};
